/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-1",
    "aws_cloud_logic_custom": [
        {
            "name": "personalWebsiteApis",
            "endpoint": "https://am9tlkxfz6.execute-api.us-west-1.amazonaws.com/prod",
            "region": "us-west-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-west-1:c2e9ee2e-fca5-4160-a428-5cb52c5c51e2",
    "aws_cognito_region": "us-west-1",
    "aws_user_pools_id": "us-west-1_5BdbaBy6h",
    "aws_user_pools_web_client_id": "14gf4ir9baijraaa0dnfora3c2",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
